import { createContext } from 'react';

const DateContext = createContext(null);

export default DateContext;
